/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import { addModal } from 'config/modals/registry';
import { wrapImport } from 'decorators/ModuleLoader';

const LinkQboCustomersModal = wrapImport(() => import(/* webpackChunkName: "modals" */ './index'));

export default addModal('LinkQboCustomersModal', LinkQboCustomersModal);
